import React, { Component } from 'react';
import MuiSwitch from '@material-ui/core/Switch';
import withStyles from '@material-ui/core/styles/withStyles';
import { colors } from '../../constants/colors';

const styles = {
  checked: {},
  bar: {},
  colorSecondary: {
    '&$checked': {
      color: colors.crunchBerry,
      '& + $bar': {
        backgroundColor: '#FFCBE5',
      },
    },
  },
};

type Props = {
  classes: any;
  className?: string;
};

class Switch extends Component<Props> {
  render = () => {
    const {
      classes,
      className,
      ...others // jscs:disable
    } = this.props;
    return (
      <MuiSwitch
        {...others}
        classes={{
          colorSecondary: classes.colorSecondary,
          track: classes.track,
          checked: classes.checked,
        }}
        className={className}
      />
    );
  };
}

export default withStyles(styles)(Switch);
